import { createFileRoute, redirect } from '@tanstack/react-router'

// Ancienne URL de « Mes données », devenue l'onglet « Mon profil ».
export const Route = createFileRoute('/_authenticated/_layout/informations-personnelles')({
  beforeLoad: () => {
    throw redirect({ replace: true, to: '/mon-profil' })
  },
})
